/**
 * <ScribbleToggle>: hand-drawn toggle switch.
 *
 * M2.T11 per IMPLEMENTATION_PLAN §7 M2.T11.
 *
 * A checkbox-backed toggle with a hand-drawn appearance.
 */

type ScribbleToggleProps = {
  checked: boolean;
  onChange: (v: boolean) => void;
  label?: string;
  id?: string;
  disabled?: boolean;
};

export function ScribbleToggle({
  checked,
  onChange,
  label,
  id,
  disabled = false,
}: ScribbleToggleProps) {
  const toggleId = id ?? "scribble-toggle";
  return (
    <div class="scribble-toggle-wrapper">
      <button
        id={toggleId}
        role="switch"
        aria-checked={checked}
        aria-label={label}
        class={["scribble-toggle", checked && "scribble-toggle--on"].filter(Boolean).join(" ")}
        disabled={disabled}
        onClick={() => onChange(!checked)}
        type="button"
      >
        <span class="scribble-toggle-thumb" />
      </button>
      {label && (
        <label class="scribble-toggle-label" for={toggleId}>
          {label}
        </label>
      )}
    </div>
  );
}
